<template>
  <div :class="'d-flex justify-center' + (mobile ? ' flex-column align-start' : ' flex-row align-center')">
    <div v-for="(item, index) in items" :key="index">

      <!-- conteudo -->
      <div :class="'d-flex justify-center align-center' + (mobile ? ' flex-row' : ' flex-column') "
      :style="{
        'margin-right': (items.length - 1  === index ) ? '0px' : (mobile ? '0px' : '100px')
        }">

        <!-- circle -->
        <div
          class="circle d-flex justify-center align-center relative-position"
          :style="{
            'background-color': item.active ? color : 'white',
            border: '3px solid ' + color,
          }">

          <!-- line -->
          <div
            class="d-flex flex-column align-center justify-center absolute-position"
            v-if="mobile ? false : true"
          >
            <div
              v-if="index !== items.length - 1"
              class="line"
              :style="{
                background: color,
              }"
            />
          </div>

          <!-- icon -->
          <v-icon size="30" :color="item.active ? 'white' : color">
            {{ item.icon }}
          </v-icon>
        </div>

        <!-- text -->
        <div :class="'d-flex flex-column justify-center my-2' + (mobile ? ' align-start' : ' align-center') "
        :style="{'margin-left': mobile ? '10px' : '0px' }">
          <span class="title ma-0 pa-0">{{ item.title }}</span>

          <span class="text-caption grey--text date ma-0 pa-0">
            {{ item.date || "---" }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
    spacing: {
      type: Number,
      default: 180,
    },
    color: {
      type: String,
      default: "success",
    },
  },
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
};
</script>

<style>
.relative-position {
  position: relative;
}

.absolute-position {
  position: absolute;
  left: 100%;
}

.circle {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}

.line {
  height: 3px;
  background: #03a9f4;
}

.date {
  text-align: center;
  font-size: 14px;
  padding-top: 10px;
}

.title {
  text-align: center;
  font-size: 14px;
  padding-top: 10px;
  opacity: 0.7;
}
</style>
